import React            from 'react';
import {
    Route,
    NavLink }           from "react-router-dom";

import * as images      from '../images';
import Role             from '../utils/Role';

import Users            from '../Manager/Users';
import DoSomething      from '../Manager/DoSomething';

import App              from '../App';

export const Index = ( app:App ) : Role => {
    const roleRoot          = "/Manager";
    const menuLinkClassName = "menu__link";
    const menuItems         = [
        <div className="menu__list-title">Admin</div>,
        <div className="menu__item">
            <NavLink className={`${menuLinkClassName}`} onClick={()=>app.menuItemClick()} to={`${roleRoot}/Users`}>
                <images.PassengerNewOrder/>
                <span className="menu__name">Users</span>
            </NavLink>
        </div>,
        <div className="menu__item">
            <NavLink className={`${menuLinkClassName}`} onClick={()=>app.menuItemClick()} to={`${roleRoot}/DoSomething`}>
                <images.PassengerNewOrder/>
                <span className="menu__name">Do Something</span>
            </NavLink>
        </div>,
    ];
    return {
        name   : "Manager",
        root   : roleRoot,
        items  : menuItems,
        routes : [
            <Route
                key={"Manager_users"}
                path={`${roleRoot}/Users`}
                element={<Users/>} />,
            <Route
                key={"Manager_dosomething"}
                path={`${roleRoot}/DoSomething`}
                element={<DoSomething/>} />,
        ]
    };
}

export default Index;
